import type { Schema, SchemaField } from '@cli-types/core-engine/schema.js'
import { toPascalCase } from '@cli-utils/text.js'
import { renderBuildGroupCreatableSelectStateStaticOptionsTemplate } from '@next-adapter/templates/renderers/generators/form/form-single/build-group-creatable-select-state.js'

export function buildGroupCreatableSelectState(
  fields: SchemaField[],
  schema: Schema,
  Singular: string
): string {
  return fields
    .map((field) => {
      const fieldPascal = toPascalCase(field.name)
      const staticOptions = (field.options ?? [])
        .map(
          (option) =>
            `{ label: ${JSON.stringify(option.label)}, value: ${JSON.stringify(option.value)} }`
        )
        .join(', ')
      return renderBuildGroupCreatableSelectStateStaticOptionsTemplate({
        fieldName: field.name,
        fieldPascal: fieldPascal,
        singular: Singular,
        schemaName: schema.name,
        staticOptions: staticOptions
      })
    })
    .join('\n')
}
